import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router/index";
import VueApexCharts from "vue3-apexcharts";
import Toast, { POSITION } from 'vue-toastification'
import { QuillEditor } from "@vueup/vue-quill";
import "./plugins/axios";
import 'vue-toastification/dist/index.css'
import echo from './plugins/echo';

// 🔹 SADECE ResizeObserver hatalarını susturan global handler
const resizeObserverErr =
    /^ResizeObserver loop completed|ResizeObserver loop limit exceeded$/;

window.addEventListener("error", (event: ErrorEvent) => {
    if (event.message && resizeObserverErr.test(event.message)) {
        event.stopImmediatePropagation();
    }
});

window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    if (
        reason &&
        typeof reason.message === "string" &&
        resizeObserverErr.test(reason.message)
    ) {
        event.stopImmediatePropagation();
    }
});

// Import styles
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@vueup/vue-quill/dist/vue-quill.bubble.css";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "remixicon/fonts/remixicon.css";

// Mahai tipografi — yerel bundle (mahkeme ağı dış CDN'e bağımlı olmamalı)
import "@fontsource/literata/400.css";
import "@fontsource/literata/400-italic.css";
import "@fontsource/literata/600.css";
import "@fontsource/literata/700.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";

// Merkezi tasarım token'ları (palet, tipografi, ölçüler)
import "./assets/scss/_tokens.scss";
import "./assets/scss/styles.css";

const app = createApp(App).use(router).use(vuetify);

app.use(Toast, {
    position: POSITION.BOTTOM_RIGHT,
    timeout: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    hideProgressBar: false,
})


app.config.globalProperties.$echo = echo;
app.provide('echo', echo);
app.use(VueApexCharts);
app.component("QuillEditor", QuillEditor);
app.mount("#app");
